import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';

/**
 * Globaler Authorization Interceptor
 * vor jedem HttpRequest wird der Interceptor automatisch aufgerufen und
 * prüft beim Requesr ob die Authorization ggf. fehlschlägt.
 * Die error-Pipe kann dann noch entsprechend angepasst werden,
 * bezüglich eines Logout-Rotings oder einer entsprechenden fehlermeldung
 *
 * @param req
 * @param next
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const skipUrls = [
    '/realms/',      // Keycloak Token / Userinfo
    '/protocol/openid-connect',
    'i18n/',
    'data/countries.json',
    'version',
    'pagateq.de/ifs',
  ];

  const configService = inject(ConfigService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // prüfen, ob Request URL eine Skip-URL enthält
  if (skipUrls.some(url => req.url.includes(url))) {
    return next(req);
  }
  if (req.url === configService.basicUrl) {
    /**
     * Basic Auth for Login-Service
     */
    req = req.clone({
      setHeaders: {
        Authorization: 'Basic ' + configService.basicAuthToken,
        'content-type': req.headers.get('content-type') || 'application/json; charset=utf-8'
      }
    });
  } else {
    /**
     * JWT-Auth (Bearer) used by all CRUD data-backend-services
     */
    req = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + authService.accessToken,
        'content-type': req.headers.get('content-type') || 'application/json; charset=utf-8'
      }
    });
  }
  return next(req).pipe(
    catchError((err: any) => {
      if (err.status === 401) {
        console.log('authInterceptor 401');
        router.navigate(['/logout']);
      }
      return throwError(() => new Error('Unauthorized Exception'));
    })
  );

};
